<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <table ref="grid" class="mdl-data-table table table-responsive dataTable no-footer dtr-inline" width="100%">
                    <thead>
                    <tr>
                        <th>Actions</th>
                        <th>Fee ID</th>
                        <th>Fee Name</th>
                        <th>Type</th>
                        <th>Payment type</th>
                        <th>Amount</th>
                        <th>Payee</th>
                        <th>Created by</th>
                    </tr>
                    </thead>
                    <tbody v-if="fees.length>0">
                    <tr v-for="fee in fees">
                        <td>
                            <ac-button class="btn btn-sm" :action="()=>{selectFee(fee)}">APPLY FEE</ac-button>
                        </td>
                        <td>{{fee.feeId}}</td>
                        <td>{{fee.name}}</td>
                        <td>{{fee.feeType}}</td>
                        <td>{{fee.strategyType}}</td>
                        <td>
                            <fee-formula :fee="fee">

                            </fee-formula>
                        </td>
                        <td>{{fee.payee}}</td>
                        <td>{{fee.creator}}</td>
                    </tr>
                    </tbody>
                    <tbody class="text-center" v-else>
                    <tr>
                        <td colspan="6">No records found</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import {formatter} from "../../../../global/formatter.js";
    import {common} from "../../../../global/common.js";
    import {api} from "../../../../global/framework/api.js";
    import dataTables from 'datatables';
    import FeeFormula from "../../../../components/shared/fees/FeeFormula.vue";

    export default {
        name: "FeeSelection",
        components: {FeeFormula},
        props: {consultantId: {type: [Number], required: true}},
        data() {
            return {
                fees: [],
                STRATEGY_TYPES: common.PAYMENT_STRATEGY_TYPES,
                grid: null
            }
        },
        methods: {
            async init() {
                this.fees = await api.get('Mediator', this.consultantId, 'GetMediatorFees');
                this.fees = this.fees.filter(f => f.feeTypeId != 6 && f.feeTypeId != 7);
                if (this.grid == null && this.fees.length > 0) {
                    //console.log(" $(this.$refs.grid) before DataTable call:", $(this.$refs.grid));
                    await this.$nextTick();//Wait until for loop has completed rendering all rows
                    this.grid = $(this.$refs.grid).DataTable({
                        responsive: true,
                        scrollX: true,
                        displayLength: 10
                    });
                    this.grid.columns.adjust().draw();
                }
            },
            selectFee(fee) {
                this.$emit('onFeeSelected', fee);
            }
        }
    }
</script>

<style scoped>

</style>